export function arrayRotate(arr, count) {
    const len = arr.length
    arr.push(...arr.splice(0, (-count % len + len) % len))
    return arr
  }

export function getStartDay(d) {
  const today = d.getDate();
  const currentDay = d.getDay();
  const newDate = d.setDate(today - currentDay );
  return new Date(newDate);
  }

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function getDateRange(offset, picked_date) {
    var date_range = []
    var start_date = getStartDay(addDays(picked_date, 7*offset))
    var end_date = addDays(start_date, 6)
    var loop = new Date(start_date)
    while(loop <= end_date){
        date_range.push([loop.toISOString().split('T')[0], `${loop.toLocaleDateString('default', { weekday: 'long' }).substring(0,3)} ${loop.getDate()} ${loop.toLocaleString('default', { month: 'long' }).substring(0,3)}`])
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
     }
    return date_range
}

export function getStartMonth(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }